import { render, staticRenderFns } from "./BitRelational.vue?vue&type=template&id=50c594fa&scoped=true"
import script from "./BitRelational.vue?vue&type=script&lang=js"
export * from "./BitRelational.vue?vue&type=script&lang=js"
import style0 from "./BitRelational.vue?vue&type=style&index=0&id=50c594fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c594fa",
  null
  
)

export default component.exports